import React, { FC } from 'react'
import { CardContainer, ContentHeadingLeft, DownloadTittle } from './Styles'
import { Row, Col } from 'antd'
import SecurityAccess from '../Download/DownloadSecurity'
import ProductionAccess from '../Download'

const DocumentGuideForTesting: FC = () => {
  return (
    <CardContainer>
      <Row justify="center" align="middle">
        <Col xs={2} sm={4} md={6} lg={8} xl={24}>
          <ContentHeadingLeft>Documentation guide for testing</ContentHeadingLeft>
          <DownloadTittle>
            You can download validation test document that will guide you through the verification of your solution:
          </DownloadTittle>
          <ProductionAccess />
          <DownloadTittle>
            From below you can download security documents that will guide you through the verification of your
            solution:
          </DownloadTittle>
          <SecurityAccess />
        </Col>
      </Row>
    </CardContainer>
  )
}

export default DocumentGuideForTesting
